import { useExistingChatByParticipants } from "@/hooks/useExistingChatByParticipants";

export const useExistingDmAndTopicChats = (
  participantIds: number[],
  enabled = true,
) => {
  const dm = useExistingChatByParticipants(participantIds, "user_dm", enabled);
  const topics = useExistingChatByParticipants(
    participantIds,
    "user_group",
    enabled,
  );

  return {
    existingDmChats: dm.existingChats,
    existingTopicChats: topics.existingChats,
    isCheckingExisting: dm.isCheckingExisting || topics.isCheckingExisting,
    error: dm.error || topics.error,
    dmError: dm.error,
    topicError: topics.error,
  };
};
